import { render, staticRenderFns } from "./app-detail-strategy.vue?vue&type=template&id=7c19e086&scoped=true&"
import script from "./app-detail-strategy.vue?vue&type=script&lang=js&"
export * from "./app-detail-strategy.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-strategy.vue?vue&type=style&index=0&id=7c19e086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c19e086",
  null
  
)

export default component.exports